module.exports = __webpack_public_path__ + "static/img/discrete_bgm.0e438f14.jpg";